import { c as _c } from "react/compiler-runtime";
import { displayPercentageDiscount } from "@website/accommodation-ui/helpers/calculatePercentageDiscount";
import { calculateSnappProDisplayPricing } from "@website/accommodation-ui/hotel-card-new/hotel-card-action/hotel-card-pricing/hotel-card-pricing.utils";
import { useHotelReserveCardFooter } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-footer/hotel-reserve-card-footer.hooks";
import { HotelReservedCardFooterTypesPropertiesType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-footer/hotel-reserved-card-footer.types";
import { HotelSnappPayBadge } from "@website/accommodation-ui/hotel-snapp-pay";
import { Button } from "@website/ui/button";
import { CounterButton } from "@website/ui/counter-button";
import { MiniChips } from "@website/ui/mini-chips";
import { Skeleton } from "@website/ui/skeleton";
import { isChannel } from "@website/utils/channel/helpers";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import { SnappProDiscountChip } from "@website/website-ui/snapp-pro-discount-chip";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
export const HotelReserveCardFooter = properties => {
  const $ = _c(58);
  const {
    availableRooms,
    price,
    priceOff,
    pricedRoomCount,
    id,
    nightCount,
    minStay: t0,
    rackIncluded,
    onRacksClick,
    view: t1,
    snappPayData,
    roomDetail,
    onRoomCountLoading,
    adjustments,
    isRoomCountPriceAvailable
  } = properties;
  const minStay = t0 === undefined ? 1 : t0;
  const view = t1 === undefined ? "default" : t1;
  const router = useRouter();
  const {
    roomCount,
    setRoomCount,
    roomSelect,
    onHandleClick,
    loading,
    openDatePicker,
    handleRecommendedHotel
  } = useHotelReserveCardFooter(properties);
  const isPriceSyncedWithRoomCount = pricedRoomCount === roomCount;
  const priceMultiplier = isPriceSyncedWithRoomCount ? 1 : roomCount;
  const [isRoomCountPricePending, setIsRoomCountPricePending] = useState(false);
  const showRoomCountPriceLoading = onRoomCountLoading || isRoomCountPricePending;
  const multipliedPrice = price * priceMultiplier;
  const multipliedPriceOff = priceOff * priceMultiplier;
  const displayAdjustments = adjustments ? {
    snapp_pro: adjustments.snapp_pro * priceMultiplier,
    peg: adjustments.peg * priceMultiplier,
    b2b: adjustments.b2b * priceMultiplier,
    other: adjustments.other * priceMultiplier,
    total: adjustments.total * priceMultiplier
  } : undefined;
  const {
    price: displayPrice,
    priceOff: t2,
    snappProDiscountPercentage
  } = calculateSnappProDisplayPricing({
    price: multipliedPrice,
    priceOff: multipliedPriceOff,
    adjustments: displayAdjustments
  });
  const displayPriceWithoutSnappPro = t2 === undefined ? 0 : t2;
  const shouldShowDiscount = displayPriceWithoutSnappPro > 0 && displayPrice > displayPriceWithoutSnappPro;
  const shouldShowSnappProDiscount = view === "default" && typeof snappProDiscountPercentage === "number" && typeof adjustments?.snapp_pro === "number" && adjustments.snapp_pro < 0;
  const displayPayablePrice = displayPriceWithoutSnappPro > 0 ? displayPriceWithoutSnappPro : displayPrice;
  const snappPayPrice = multipliedPriceOff > 0 ? multipliedPriceOff : multipliedPrice;
  let t3;
  if ($[0] !== isRoomCountPriceAvailable || $[1] !== setRoomCount) {
    t3 = nextRoomCount => {
      if (isRoomCountPriceAvailable && !isRoomCountPriceAvailable(nextRoomCount)) {
        setIsRoomCountPricePending(true);
      }
      setRoomCount(nextRoomCount);
    };
    $[0] = isRoomCountPriceAvailable;
    $[1] = setRoomCount;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleRoomCountChange = t3;
  let t4;
  let t5;
  if ($[3] !== isPriceSyncedWithRoomCount) {
    t4 = () => {
      if (isPriceSyncedWithRoomCount) {
        setIsRoomCountPricePending(false);
      }
    };
    t5 = [isPriceSyncedWithRoomCount];
    $[3] = isPriceSyncedWithRoomCount;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  const t6 = `flex items-center justify-between pb-4 ${view === "mobile" ? "flex-col pt-3" : "flex-col pt-3 lg:min-h-[68px] lg:flex-row lg:px-4 lg:pt-4"}`;
  const t7 = "flex w-full flex-row flex-wrap items-center justify-between";
  const t8 = `${view === "mobile" ? "hidden" : "text-caption hidden lg:order-1 lg:me-4 lg:block"}`;
  let t9;
  if ($[6] !== t8) {
    t9 = <div className={t8}>تعداد اتاق</div>;
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const t10 = `text-caption mr-4 ltr:ml-4 ${view === "mobile" ? "" : "lg:order-4 lg:m-0"}`;
  let t11;
  if ($[8] !== nightCount || $[9] !== router.locale) {
    t11 = numberConvert(nightCount, {
      locale: router.locale
    });
    $[8] = nightCount;
    $[9] = router.locale;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  const t12 = `قیمت برای ${t11} شب`;
  let t13;
  if ($[11] !== t10 || $[12] !== t12) {
    t13 = <div className={t10}>{t12}</div>;
    $[11] = t10;
    $[12] = t12;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  const t14 = `text-subtitle-1 ml-4 flex min-h-[44px] min-w-[132px] flex-col items-end justify-center text-end ltr:mr-4 ${view === "mobile" ? "" : "lg:order-5 lg:mr-4 lg:ltr:ml-0"}`;
  const t15 = showRoomCountPriceLoading ? <div className="flex w-[132px] flex-col gap-2 self-end"><Skeleton height={20} /></div> : <>{shouldShowDiscount && <div className="flex flex-row items-center justify-end gap-2"><span className="text-body-2 text-on-surface-medium-emphasis line-through">{numberConvert(numberSeparator(displayPrice), {
          locale: router.locale
        })}</span><MiniChips color="primary" text={displayPercentageDiscount(displayPrice, displayPriceWithoutSnappPro)} variant="contained" /></div>}<div>{numberConvert(numberSeparator(displayPayablePrice), {
        locale: router.locale
      })}<span className="text-subtitle-2 px-1">تومان</span></div></>;
  let t16;
  if ($[14] !== t14 || $[15] !== t15) {
    t16 = <div className={t14}>{t15}</div>;
    $[14] = t14;
    $[15] = t15;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  const t17 = `bg-outline-thin mb-4 mt-3 block h-px w-full ${view === "mobile" ? "" : "lg:hidden"} ${snappPayData?.isEligible && snappPayData?.showDownPayment ? "hidden" : ""}`;
  let t18;
  if ($[17] !== t17) {
    t18 = <div className={t17} />;
    $[17] = t17;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] !== shouldShowSnappProDiscount || $[20] !== snappProDiscountPercentage) {
    t19 = shouldShowSnappProDiscount && <div className="min-w-fit basis-full max-lg:mx-4 max-lg:pb-4 lg:order-3 lg:basis-0 lg:px-2"><SnappProDiscountChip className="py-2" showDesc={true} percentage={snappProDiscountPercentage} /></div>;
    $[19] = shouldShowSnappProDiscount;
    $[20] = snappProDiscountPercentage;
    $[21] = t19;
  } else {
    t19 = $[21];
  }
  let t20;
  if ($[22] !== snappPayData || $[23] !== snappPayPrice) {
    t20 = snappPayData?.isEligible && snappPayData?.showDownPayment && <div className="flex-auto basis-full max-lg:pb-4 lg:order-3 lg:basis-0 lg:px-2">{!isChannel(["ads"]) && <HotelSnappPayBadge {...snappPayData} page="hotelPage" price={snappPayPrice} />}</div>;
    $[22] = snappPayData;
    $[23] = snappPayPrice;
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  const t21 = `ms-4 !h-[36px] gap-0 ${view === "mobile" ? "" : "lg:order-2 lg:m-0"} ${view === "mobile" || snappPayData?.isEligible && snappPayData?.showDownPayment ? "" : "lg:flex-auto"}`;
  const t22 = roomCount <= 1 || showRoomCountPriceLoading;
  const t23 = roomCount >= availableRooms || showRoomCountPriceLoading;
  let t24;
  if ($[25] !== handleRoomCountChange || $[26] !== roomCount || $[27] !== t21 || $[28] !== t22 || $[29] !== t23) {
    t24 = <CounterButton className={t21} color="secondary" decreaseDisabled={t22} increaseDisabled={t23} locale="fa" onChange={handleRoomCountChange} size="small" value={roomCount} variant="outline" />;
    $[25] = handleRoomCountChange;
    $[26] = roomCount;
    $[27] = t21;
    $[28] = t22;
    $[29] = t23;
    $[30] = t24;
  } else {
    t24 = $[30];
  }
  let t25;
  if ($[31] !== handleRecommendedHotel || $[32] !== id || $[33] !== loading || $[34] !== minStay || $[35] !== nightCount || $[36] !== onHandleClick || $[37] !== onRacksClick || $[38] !== openDatePicker || $[39] !== rackIncluded || $[40] !== roomCount || $[41] !== roomDetail?.showRoomDetail || $[42] !== roomSelect || $[43] !== router.locale || $[44] !== view) {
    t25 = Number(nightCount) >= Number(minStay) ? rackIncluded && !roomDetail?.showRoomDetail ? <Button className={view === "mobile" ? "ml-4 w-[133px] ltr:mr-4" : "ml-4 w-[133px] lg:order-6 lg:col-span-2 lg:m-0 lg:w-[94px] ltr:mr-4"} onClick={onRacksClick} size="small">{`رزرو ${numberConvert(roomCount, {
        locale: router.locale
      })} اتاق`}</Button> : <Button className={view === "mobile" ? "ml-4 w-[133px] ltr:mr-4" : "ml-4 w-[133px] lg:order-6 lg:col-span-2 lg:m-0 lg:w-[94px] ltr:mr-4"} loading={id === roomSelect ? loading : false} onClick={onHandleClick} size="small">{`رزرو ${numberConvert(roomCount, {
        locale: router.locale
      })} اتاق`}</Button> : <div className={`order-6 mt-2 flex w-full flex-col px-4 ${view === "mobile" ? "" : "lg:flex-row lg:items-center lg:px-0"}`}><div className={`text-body-2 text-primary mb-2 flex-auto ${view === "mobile" ? "" : "lg:m-0"}`}>{minStay === 20 ? "\u0627\u06CC\u0646 \u0627\u062A\u0627\u0642 \u062F\u0631 \u062A\u0627\u0631\u06CC\u062E \u0648\u0631\u0648\u062F \u0627\u0646\u062A\u062E\u0627\u0628\u06CC \u0634\u0645\u0627 \u067E\u0630\u06CC\u0631\u0634 \u0646\u062F\u0627\u0631\u062F \u0644\u0637\u0641\u0627 \u062A\u0627\u0631\u06CC\u062E \u0627\u0642\u0627\u0645\u062A \u062E\u0648\u062F \u0631\u0627 \u062A\u063A\u06CC\u06CC\u0631 \u062F\u0647\u06CC\u062F" : `حداقل ${numberConvert(minStay, {
          locale: router.locale
        })} شب اقامت`}</div><div className="flex flex-row gap-2"><Button className={view === "mobile" ? "w-full" : "w-full lg:w-[94px]"} onClick={openDatePicker} size="small">تغییر تاریخ</Button><Button className={view === "mobile" ? "w-full" : "w-full lg:w-[122px]"} onClick={handleRecommendedHotel} size="small">هتل های مشابه</Button></div></div>;
    $[31] = handleRecommendedHotel;
    $[32] = id;
    $[33] = loading;
    $[34] = minStay;
    $[35] = nightCount;
    $[36] = onHandleClick;
    $[37] = onRacksClick;
    $[38] = openDatePicker;
    $[39] = rackIncluded;
    $[40] = roomCount;
    $[41] = roomDetail?.showRoomDetail;
    $[42] = roomSelect;
    $[43] = router.locale;
    $[44] = view;
    $[45] = t25;
  } else {
    t25 = $[45];
  }
  let t26;
  if ($[46] !== t13 || $[47] !== t16 || $[48] !== t18 || $[49] !== t19 || $[50] !== t20 || $[51] !== t24 || $[52] !== t25 || $[53] !== t9) {
    t26 = <div className={t7}>{t9}{t13}{t16}{t18}{t19}{t20}{t24}{t25}</div>;
    $[46] = t13;
    $[47] = t16;
    $[48] = t18;
    $[49] = t19;
    $[50] = t20;
    $[51] = t24;
    $[52] = t25;
    $[53] = t9;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== t26 || $[56] !== t6) {
    t27 = <div className={t6}>{t26}</div>;
    $[55] = t26;
    $[56] = t6;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  return t27;
};